<script setup>
import PlanCard from './PlanCard.vue'
import FeaturePill from './FeaturePill.vue'

const plans = [
  {
    planNumber: 1,
    title: 'Content Access',
    description: "Self-paced learning with tutor's recorded library",
    color: 'blue',
    features: [
      { text: 'Recorded lessons', icon: 'check' },
      { text: 'Revision resources', icon: 'check' },
      { text: 'Learn at your pace', icon: 'check' }
    ]
  },
  {
    planNumber: 2,
    title: 'Group Tutoring',
    description: 'Live group sessions plus content access',
    color: 'purple',
    features: [
      { text: 'Weekly group sessions', icon: 'check' },
      { text: 'Learn with peers', icon: 'check' },
      { text: 'Full content library', icon: 'video', isHighlight: true }
    ]
  },
  {
    planNumber: 3,
    title: '1:1 Tutoring',
    description: 'Personal sessions with full access',
    color: 'green',
    features: [
      { text: 'Weekly 1:1 sessions', icon: 'check' },
      { text: 'Message tutor anytime', icon: 'check' },
      { text: 'Personalised guidance', icon: 'check' },
      { text: 'Full content library', icon: 'video', isHighlight: true }
    ]
  }
]
</script>

<template>
  <section class="py-12 md:py-24 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
    <div class="max-w-7xl mx-auto px-4 md:px-8">
      <div class="text-center mb-12">
        <h2 class="text-4xl md:text-5xl font-bold text-gray-900 mb-4">How Bindle works</h2>
        <p class="text-md md:text-xl text-gray-600 max-w-2xl mx-auto mb-6">Choose the membership that fits your learning style and budget</p>
        <p class="text-base font-semibold text-gray-700 bg-white inline-block px-6 py-2 rounded-full shadow-sm">All plans are weekly subscriptions</p>
      </div>

      <!-- Feature Pills -->
      <div class="flex flex-wrap items-center justify-center gap-4 md:gap-8 mb-16 max-w-4xl mx-auto">
        <FeaturePill icon="infinity" text="Constant access" color="blue" />
        <FeaturePill icon="sliders" text="Flexible plans" color="purple" />
        <FeaturePill icon="calendar" text="Weekly tutoring" color="green" />
      </div>

      <!-- Plan Cards -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        <PlanCard
          v-for="plan in plans"
          :key="plan.planNumber"
          v-bind="plan"
        />
      </div>
    </div>
  </section>
</template>
